import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Menu } from '@linktivity/link-ui';
import { useStore } from '@/stores';
import styles from './sidebar.module.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const { auth } = useStore();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.inner}>
        <Menu className={styles.menu} accordion>
          <Menu.MenuItem label={t('views.dashboard.title')} to="/dashboard" />
          <Menu.SubMenu label={t('views.seatMap.title')} name="booking">
            {auth.isTokyo && (
              <Menu.MenuItem
                label={t('views.dashboard.tokyo')}
                to="/seat-map/tokyo"
              />
            )}
            {auth.isOsaka && (
              <Menu.MenuItem
                label={t('views.dashboard.osaka')}
                to="/seat-map/osaka"
              />
            )}
          </Menu.SubMenu>
          <Menu.MenuItem label={t('views.redeem.title')} to="/redeem" />
        </Menu>
      </div>
    </aside>
  );
};

const ObserverSidebar = observer(Sidebar);
export default ObserverSidebar;
